var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDreamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0646 0H0V10.6657C2.19807 10.6657 4.08376 12.0089 4.88958 13.9231C5.21094 14.6864 5.96268 15.1764 6.78733 15.1764C7.61206 15.1764 8.3638 14.6864 8.68516 13.9231C9.49089 12.0089 11.3767 10.6657 13.5747 10.6657C16.5058 10.6657 18.8818 13.054 18.8818 16C18.8818 18.946 16.5058 21.3343 13.5747 21.3343C11.3767 21.3343 9.49089 19.9911 8.68516 18.0769C8.3638 17.3135 7.61206 16.8236 6.78733 16.8236C5.96268 16.8236 5.21094 17.3135 4.88958 18.0769C4.08376 19.9911 2.19807 21.3343 0 21.3343V32H13.0646C21.8562 32 28.9834 24.8365 28.9834 16C28.9834 7.16342 21.8562 0 13.0646 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDreamIcon);
export default __webpack_public_path__ + "static/media/dream-icon.a93100651499735f927fca85dda6e83b.svg";
export { ForwardRef as ReactComponent };